module.exports = __webpack_public_path__ + "img/kairan1.e0624e01.png";